export default interface GeniChat {
  invoiceId: number;
  selected: boolean;
}

export const geniChatDefaultProps: GeniChat = {
  invoiceId: 0,
  selected: false,
};
